module.exports = __webpack_public_path__ + "img/y-261.af6e804d.png";